import { LocalStorageAccountService } from './LocalStorageAccountService';
import { FirebaseAccountService } from './FirebaseAccountService';

/**
 * Factory for creating account storage service instances
 */
export class AccountStorageFactory {
  /**
   * Create a storage service based on storage mode
   * @param {string} storageMode - 'offline' or 'cloud'
   * @param {Object} [user] - Firebase user object (required for cloud mode)
   * @returns {import('./IAccountStorageService').IAccountStorageService}
   */
  static createService(storageMode, user = null) {
    if (storageMode === 'cloud' && user) {
      return new FirebaseAccountService(user.uid);
    }

    // Default to localStorage for offline mode or when user is not available
    return new LocalStorageAccountService();
  }
}
